







  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"MyBooking"
})
export default class Profil extends Vue {}
